module.exports = __webpack_public_path__ + "img/loading.09f82c13.svg";